// Right-side slide-over panel. Mounts a backdrop + a fixed sheet on
// the right edge; the parent supplies the title, body, and footer.
import type { ReactNode } from "react";
import { X } from "lucide-react";

export function Sheet({
  open,
  onClose,
  title,
  children,
  footer,
}: {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  if (!open) return null;
  return (
    <>
      <div
        className="tp-sheet-backdrop"
        onClick={onClose}
        aria-hidden
      />
      <aside className="tp-sheet" role="dialog" aria-modal="true">
        <header className="tp-sheet-header">
          <div className="tp-sheet-title">{title}</div>
          <button
            type="button"
            className="tp-icon-action"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </header>
        <div className="tp-sheet-body">{children}</div>
        {footer ? <div className="tp-sheet-footer">{footer}</div> : null}
      </aside>
    </>
  );
}
